/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelstatusdone2Inputs */

const en_channelstatusdone2 = /** @type {(inputs: Channelstatusdone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivered`)
};

const de_channelstatusdone2 = /** @type {(inputs: Channelstatusdone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugestellt`)
};

/**
* | output |
* | --- |
* | "Delivered" |
*
* @param {Channelstatusdone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelstatusdone2 = /** @type {((inputs?: Channelstatusdone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelstatusdone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelstatusdone2(inputs)
	return de_channelstatusdone2(inputs)
});
export { channelstatusdone2 as "channelStatusDone" }